import React from 'react';
import PropTypes from 'prop-types';
import * as rights from '../../../../model/rights';
import GenericRow from './GenericRow';

class MaxAllowedDevicesRow extends GenericRow {
  constructor(props) {
    super(props);
  }

  render() {
    return <div className={'row col-md-12'}>
      <div className={'col-md-4'} style={{marginTop: '12px'}}>
        <div style={this.getColumnStyle()}>
          <span>MAX ALLOWED DEVICES</span>
        </div>
      </div>
      <div className={'col-md-8'}>
        {this.getTableDataContent(rights.MAX_ALLOWED_DEVICES_READ_PRIVILEGE)}
        {this.getTableDataContent(rights.MAX_ALLOWED_DEVICES_ADD_PRIVILEGE)}
        {this.getEmptyDataContent()}
        {this.getEmptyDataContent()}
        {this.getEmptyDataContent()}
        {this.getEmptyDataContent()}
      </div>
    </div>;
  }
}

MaxAllowedDevicesRow.propTypes = {
  permissionSection: PropTypes.object,
  onChange: PropTypes.func,
};

export default MaxAllowedDevicesRow;
